<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand" to="/dashboard">
            <img :src="logo" class="navbar-brand-img" alt="MSacco">
                <!-- <h1 class="display-3 logoName">MSacco</h1> -->
            </router-link>

            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <base-dropdown class="nav-item" position="right">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar avatar-sm rounded-circle">
                                 <!-- <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg"> -->
                                <v-avatar color="red">
                                  <span class="white--text headline">{{acronym}}</span>
                                </v-avatar>
                              </span>
                            </div>
                        </a>

                       <right-side-bar-content/>
                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/dashboard">
                               <img :src="logo" alt="MSacco">
                               <!-- <h1 class="display-4 logoName">MSacco</h1> -->
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>
                <!--Divider-->
                <hr class="my-3">

                <!--Navigation-->
                <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <a class="nav-link"
                           @click="logout">
                            <i class="fa fa-power-off"></i> Logout
                        </a>
                    </li>
                </ul>
            </div>
            </div>
    </nav>
</template>
<script>
import Swal from 'sweetalert2'
  import NavbarToggleButton from '@/components/NavbarToggleButton'
  import RightSideBarContent from '@/components/SidebarPlugin/RightSideBarContent'

  export default {
    name: 'sidebar',
    data() {
      return {
          acronym: localStorage.getItem('acronym')
      };
    },
    components: {
      NavbarToggleButton,
        RightSideBarContent
    },
    props: {
      logo: {
        type: String,
        default: 'img/logo2.png',
        description: 'Sidebar app logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
        logout(){
          Swal.fire({
              title: 'Are you sure?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Logout!'
            }).then((result) => {
              if (result.value) {
                localStorage.clear();
                this.$router.push('login')
              }
            })
            
        },
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
<style>
    @import url('https://fonts.googleapis.com/css?family=Dancing+Script|Satisfy&display=swap');
    .logoName{
        font-family: 'Dancing Script', cursive;
    }
</style>
